var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinnerGap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    id: "spinner-gap",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    x2: 128,
    y1: 32,
    y2: 64,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 224,
    x2: 192,
    y1: 128,
    y2: 128,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 195.882,
    x2: 173.255,
    y1: 195.882,
    y2: 173.255,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    x2: 128,
    y1: 224,
    y2: 192,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 60.118,
    x2: 82.745,
    y1: 195.882,
    y2: 173.255,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    x2: 64,
    y1: 128,
    y2: 128,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 60.118,
    x2: 82.745,
    y1: 60.118,
    y2: 82.745,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerGap);
export default __webpack_public_path__ + "static/media/spinner-gap.773c9dcda2e25d2891504ae71dbe8922.svg";
export { ForwardRef as ReactComponent };